import React from "react";
import { Link } from "react-router-dom";
import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * Stale-audit reminder banner. Shown above the score gauge when the user's
 * most recent audit is older than 30 days. Dismissable for 7 days via a
 * caller-supplied `onDismiss` handler that persists the snooze.
 *
 * Props are flat values + a callback — no shared state with the parent,
 * so this component is fully memo-safe.
 */
export default function StaleAuditBanner({ days, onDismiss }) {
  return (
    <div
      className="mt-6 rounded-md border border-[var(--rg-amber)] bg-[var(--rg-amber-soft)] px-4 py-3 flex items-start gap-3"
      data-testid="stale-audit-banner"
    >
      <RefreshCw className="w-4 h-4 text-[var(--rg-amber)] mt-1 flex-shrink-0" />
      <div className="flex-1 text-sm text-[var(--rg-text-strong)]">
        Your last readiness check was <strong>{days} days</strong> ago.
        Regulations update frequently — consider running a fresh audit to see
        your current position.
      </div>
      <Link to="/onboarding">
        <Button
          size="sm"
          className="bg-[var(--rg-amber)] text-[var(--rg-on-sage)] hover:bg-[var(--rg-amber)] font-semibold"
          data-testid="stale-audit-run-fresh"
        >
          Run Fresh Audit
        </Button>
      </Link>
      <button
        type="button"
        onClick={onDismiss}
        className="text-[var(--rg-muted)] hover:text-[var(--rg-text-strong)] text-xs ml-1"
        data-testid="stale-audit-dismiss"
        aria-label="Dismiss"
      >✕</button>
    </div>
  );
}
